export const TRAIT_PREVIEW_NUM_ROWS_ALWAYS_SHOW = 4;
export const OUTFIT_CATEGORY_KEY = 'outfit';
export const FULL_BODY_CATEGORY_KEYS = [
  'breast',
  'outfit',
  'body',
  'save',
  'top',
  'bottom',
  'footwear',
  'sock',
  'outerwear',
  'one_piece',
  'my_closet',
];
export const NO_ROTATION = null;
